/** Zone danger : supprimer une société test — interdit dès qu’une pièce est validée. */
import { useEffect, useState } from "react";
import { facturxFetch } from "../../api/client";
import { Button } from "../../components/Button";
import { Field } from "../../components/Field";
import "../../components/confirmModal.css";
import { useCompany } from "../../company/CompanyProvider";

type Probe = {
  can_delete: boolean;
  message: string;
  drafts: number;
};

export function CompanyDelete({ companyId, legalName }: { companyId: number; legalName: string }) {
  const { deleteCompany } = useCompany();
  const [open, setOpen] = useState(false);
  const [probe, setProbe] = useState<Probe | null>(null);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setTyped("");
    setErr("");
    setProbe(null);
    facturxFetch<Probe>(`companies.php?delete_probe=1&id=${companyId}`)
      .then((data) => setProbe({ can_delete: data.can_delete, message: data.message, drafts: Number(data.drafts) }))
      .catch((e) => setErr(e instanceof Error ? e.message : "Vérification impossible"));
  }, [open, companyId]);

  async function confirm() {
    if (!probe?.can_delete) return;
    setBusy(true);
    setErr("");
    try {
      await deleteCompany(companyId, typed);
      setOpen(false);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Suppression impossible");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fx-co-danger">
      <h3>Supprimer la société</h3>
      <p>
        Uniquement une société test, sans facture ni avoir validés. Dès qu’une pièce est émise, la suppression est
        interdite.
      </p>
      <Button variant="danger" disabled={busy} onClick={() => setOpen(true)}>
        Supprimer cette société
      </Button>
      {open ? (
        <div className="fx-modal" role="dialog" aria-modal="true" aria-labelledby="fx-del-co-title">
          <button type="button" className="fx-modal__backdrop" aria-label="Fermer" disabled={busy} onClick={() => setOpen(false)} />
          <div className="fx-modal__card">
            <h2 id="fx-del-co-title" className="fx-modal__title">
              Supprimer {legalName} ?
            </h2>
            {probe && !probe.can_delete ? (
              <p className="fx-modal__text">{probe.message}</p>
            ) : (
              <>
                <p className="fx-modal__text">{probe?.message || "Vérification…"}</p>
                {probe?.can_delete ? (
                  <div className="mt-3">
                    <Field
                      label="Nom exact de la société"
                      value={typed}
                      autoComplete="off"
                      onChange={(e) => setTyped(e.target.value)}
                    />
                  </div>
                ) : null}
              </>
            )}
            {err ? <p className="fx-co-form__err mt-2">{err}</p> : null}
            <div className="fx-modal__actions">
              <Button variant="ghost" disabled={busy} onClick={() => setOpen(false)}>
                Annuler
              </Button>
              {probe?.can_delete ? (
                <Button
                  variant="danger"
                  disabled={busy || typed.trim() === ""}
                  onClick={() => void confirm()}
                >
                  {busy ? "Suppression…" : "Supprimer définitivement"}
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
